import ModalContainer from 'components/modal/modal-container'

import { FormControl, MenuItem, Select } from '@mui/material'
import ModalActions from 'components/modal/modal-actions'
import { Button } from '@mui/material'

import { closeModal } from 'actions/app'

import { editMultipleField } from 'api/field'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect, useState } from 'react'

import type { FieldModel } from 'store/state/field'
import type { AppState } from 'state/index.js'

export type ReactivateFieldsProps = {
  fields: FieldModel[]
  callback: () => void
}

export type RetireFieldsProps = {
  fields: FieldModel[]
  callback: () => void
}

export default function RetireFields(props: RetireFieldsProps) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { fields, callback } = props
  const harvestYears = useSelector((state: AppState) => state.harvest.years)
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear())
  const [availableYears, setAvailableYears] = useState<number[]>([
    new Date().getFullYear(),
  ])

  const closePopup = () => dispatch(closeModal())

  useEffect(() => {
    if (harvestYears?.length) {
      const currentYear = new Date().getFullYear()
      const firstYear = harvestYears[harvestYears.length - 1].harvestYr
      const years: number[] = []
      for (let year = currentYear; year >= firstYear; year--) {
        years.push(year)
      }
      setAvailableYears(years)
      setSelectedYear(currentYear)
    }
  }, [harvestYears])

  const onSubmit = useCallback(() => {
    const data: { id: number; retiredAt: string }[] = []
    for (let i = 0; i < fields.length; i++) {
      data.push({
        id: fields[i].id,
        retiredAt: new Date(`${selectedYear}-01-01`).toISOString(),
      })
    }
    //@ts-expect-error
    dispatch(editMultipleField(data, callback))
    dispatch(closeModal())
  }, [fields, callback, dispatch, selectedYear])

  const onYearChange = (event: any) => {
    setSelectedYear(event.target.value as number)
  }

  return (
    <ModalContainer>
      <div>
        {t('retire_items', {
          count: fields.length,
          item: fields.length > 1 ? t('fields') : t('field'),
        })}
        <br />
        <br />
        {t('retire_fields_warning')}
        <br />
        <br />
        {t('select_retirement_year')}
        <FormControl size="small" style={{ flex: '0.45' }}>
          <Select
            sx={{ fontSize: '0.75em', height: '28px' }}
            value={selectedYear}
            onChange={onYearChange}
          >
            {!availableYears?.length && (
              <MenuItem key={selectedYear} value={selectedYear}>
                {selectedYear}
              </MenuItem>
            )}
            {availableYears?.length &&
              availableYears.map((v) => {
                return (
                  <MenuItem key={v} value={v}>
                    {v}
                  </MenuItem>
                )
              })}
          </Select>
        </FormControl>
      </div>
      <ModalActions>
        <Button variant="contained" color="secondary" onClick={closePopup}>
          {t('cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={onSubmit}>
          {t('retire')}
        </Button>
      </ModalActions>
    </ModalContainer>
  )
}
